<app-status-icon
  [fill]="unread === 'unset' ? 'var(--bnear-brand)' : 'white'"
  [ngClass]="{ unread: unread !== 'unset' }"
></app-status-icon>
